<template>
  <div class="idc-wrap">
    <!-- 标题区域 -->
    <div class="row mb-1">
      <div class="col-12">
        <h2 class="title-main">
          {{ $t('data_card2.title') }}
        </h2>
        <p class="title-sub">{{ $t('data_card2.title_sub') }}</p>
      </div>
    </div>

    <!-- Bootstrap row直接子元素必须是col-md，router-link放在col-item内部 -->
    <div class="row">
      <div class="col-md col-item">
        <router-link to="/bess" class="nav-link">
          <div class="card-inner">
            <div class="num css-count" data-end="5000">
              <span class="num-val"></span>+
            </div>
            <div class="label">
              {{ $t('data_card2.city.name') }}
            </div>
            <div class="desc">
              {{ $t('data_card2.city.text') }}
            </div>
            <div class="desc">
              <img src="@/assets/images/cc/item01.gif" />
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-md col-item">
        <router-link to="/transformer" class="nav-link">
          <div class="num css-count" data-end="23500">
            <span class="num-val"></span>+
          </div>
          <div class="label">{{ $t('data_card2.datacetre.name') }}</div>
          <div class="desc">
            {{ $t('data_card2.datacetre.text') }}
          </div>
          <div class="desc">
            <img src="@/assets/images/cc/item02.gif" />
          </div>
        </router-link>
      </div>

      <div class="col-md col-item">
        <router-link to="/powerStation" class="nav-link">
          <div class="num css-count" data-end="4000">
            <span class="num-val"></span>+
          </div>
          <div class="label">{{ $t('data_card2.memory.name') }}</div>
          <div class="desc">
            {{ $t('data_card2.memory.text') }}
          </div>
          <div class="desc">
            <img src="@/assets/images/cc/item03.gif" />
          </div>
        </router-link>
      </div>

      <div class="col-md col-item">
        <router-link to="/chargingEquipment" class="nav-link">
          <div class="num css-count" data-end="23907">
            <span class="num-val"></span>+
          </div>
          <div class="label">{{ $t('data_card2.capacity.name') }}</div>
          <div class="desc">
            {{ $t('data_card2.capacity.text') }}
          </div>
          <div class="desc">
            <img src="@/assets/images/cc/item04.gif" /></div
        ></router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdcBootstrapCard',
  mounted() {
    this.startCssCountAnimation();
  },
  methods: {
    startCssCountAnimation() {
      const items = document.querySelectorAll('.css-count');
      const duration = 5000;

      items.forEach((el) => {
        const end = Number(el.dataset.end);
        const needFormat = el.dataset.format === 'true';
        const valDom = el.querySelector('.num-val');
        const startTime = performance.now();

        function animate(time) {
          const progress = Math.min((time - startTime) / duration, 1);
          const current = Math.floor(progress * end);
          valDom.innerText = needFormat ? current.toLocaleString() : current;

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        }
        requestAnimationFrame(animate);
      });
    },
  },
};
</script>

<style scoped>
.idc-wrap {
  color: #fff;
  background-image: url('@/assets/images/cc/bg2.gif');
  background-size: cover;
  background-repeat: no-repeat;
  margin: 20px 0;
  border-radius: 10px;
  overflow: hidden;
}

.title-main {
  font-size: 20px;
  font-weight: 700;
  margin: 30px 0 0 0;
  padding: 0 30px;
}
.title-sub {
  font-size: 16px;
  margin: 0 0 15px 0;
  padding: 0 30px;
}

.col-item {
  padding: 24px 16px;
  border-right: 1px solid #ffffff40;
  transition: all 0.3s ease;
}
.col-item:hover {
  cursor: pointer;
  margin-top: -3px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
}
.col-item:last-child {
  border-right: none;
}

/* router-link a标签重置 */
.nav-link {
  display: block;
  color: #fff;
  text-decoration: none;
}
.card-inner {
  width: 100%;
}

.num {
  font-size: 34px;
  font-weight: bold;
  margin-bottom: 12px;
}
.label {
  font-size: 18px;
  margin-bottom: 16px;
}
.desc {
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}
.desc img {
  margin: 10px 0px 10px 10px;
  width: 90%;
  border-radius: 10px;
}
</style>
